import { IFieldSchema } from "../../../";

/**
 * Helper function is meant process the default IFieldSchema option
 * 
 * @param field: IFieldSchema
 *   The field we are looking to process
 * @return: IFieldSchema
 *   The built field schema that should be used when creating the default for this field
 */
export function ProcessDefault(field: IFieldSchema): IFieldSchema {
    if (field.default === true) {
        field.default = () => { return new field.type(); }
    } else if (typeof field.default === "string") {
        // Figure out how to do this without the object.
    }
    return field;
}